import type { Credentials, CredentialsFetcher } from '@wizbii/algolia';
import type { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environment';

@Injectable()
export class AlgoliaCredentialFetcherService implements CredentialsFetcher {
  private readonly httpClient = inject(HttpClient);

  fetchCredentials(): Observable<Credentials> {
    return this.httpClient.get<Credentials>(`${environment.api.fibii}/_credentials/algolia`);
  }
}
